import Vue from 'vue'
import Vuex from 'vuex'
import VueNestedMenu from 'vue-nested-menu';


Vue.use(VueNestedMenu);
Vue.use(Vuex)
/**
 * Importação dos módulos
 */
import getters from './getters'
import user from './modules/user'
import products from './modules/products'
import categories from './modules/categories'
import addresses from './modules/addresses'
import system from './modules/system'
import cart from './modules/cart'

export default new Vuex.Store({
  modules: {
    system,
    user,
    products,
    categories,
    addresses,
    cart
  },
  getters
})
